import { ROUTER } from "./constants";

// postMessage contract between the WebApp and the embedded omnicasa-email-editor iframe (FRO-11119).
export const EMAIL_EDITOR_EVENTS = {
	// editor -> webapp
	DIRTY_STATE: "dirty-state",
	LOCATION_CHANGED: "location-changed",
	// webapp -> editor
	SAVE_REQUEST: "save-request"
};

export const WEBAPP_MESSAGE_SOURCE = "omnicasa-webapp";

// Store the editor-reported path.
export const EMAIL_EDITOR_LAST_PATH_KEY = "omnicasa-email-editor-last-path";

export const EMAIL_TAB_IDENTIFY_DATA = { name: ROUTER.EMAIL_WEBSITE };
